import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {EntityForm} from '@catuimodels/shared/entity-form';
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {SelectOption} from "@catuiform/types";
import {isNullOrUndefined} from "util";
import {Router} from "@angular/router";
import {Project} from "@catcore/types/api-v2";
import {LinkItem} from "@catui/types";
import {extractDataFromModel, sortByLabelFunc} from "@catcore/utils";

const componentBaseName = 'feature-ggw-device-form';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-project-ggw-device-form',
  templateUrl: './project-ggw-device-form.component.html',
})
export class ProjectGgwDeviceFormComponent extends EntityForm implements OnInit, OnDestroy {
  @HostBinding('class') classNames = defaultClassNames;
  projectUnitOptions: SelectOption[];

  linkedGgwFixedRoutesOut = [];
  linkedGgwFixedRoutesIn = [];

  yesNoDefaultOptions: SelectOption[] = [
    {label: 'Default', value: null},
    {label: 'Yes', value: true},
    {label: 'No', value: false},
  ];

  aircraftDeviceOptions = [
    {label: 'Default', value: null},
    {label: 'Yes', value: true},
    {label: 'No', value: false},
  ];

  private currentResourceService;
  private featureResourceService;

  private projectSubscription;
  private project: Project;

  labels = {
    unit: 'Unit',
    aircraft_device: 'Aircraft Device',
  };

  get formIsReady() {
    return !isNullOrUndefined(this.form);
  }

  constructor(formBuilder: FormBuilder,
              private genericService: GenericResourceService,
              private router: Router) {
    super(formBuilder);
    this.setSubmitNullValueFields(['force_exclude_from_gui', 'aircraft_device']);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  onEntityReceived(entity) {
    this.currentResourceService = this.genericService.findServiceForResource(this.resourceUri);
    this.featureResourceService = this.genericService.findServiceForResource(entity._links.feature.href);

    this.linkedGgwFixedRoutesOut = [];
    extractDataFromModel(entity, 'ggw_fixed_routes_out').forEach((item) => {
      this.linkedGgwFixedRoutesOut.push({label: item.label});
    });
    this.linkedGgwFixedRoutesOut.sort(sortByLabelFunc);

    this.linkedGgwFixedRoutesIn = [];
    extractDataFromModel(entity, 'ggw_fixed_routes_in').forEach((item) => {
      this.linkedGgwFixedRoutesIn.push({label: item.label});
    });
    this.linkedGgwFixedRoutesIn.sort(sortByLabelFunc);
  }

  refreshResource() {
    this.currentResourceService.refresh();
  }

  protected afterDelete() {
    this.featureResourceService.refresh();
  }

  protected afterFormSubmit() {
    this.featureResourceService.refresh();
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-device/components/project-ggw-device-form/project-ggw-device-form.component.ts